import React, { useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { AlarmViewDevicesListDatatable } from "@/helpers/alarmViewDevicesListDatatable";

function ViewDevicesModal({ open, onClose, templateId }) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);

  const handleLoaded = json => {
    setTotal(json.recordsTotal);
  };

  return (
    <Modal
      title={t({ defaultMessage: "设备数（{num}）" }, { num: total })}
      width={800}
      open={open}
      onClose={onClose}
      onConfirm={onClose}
    >
      <AlarmViewDevicesListDatatable
        templateId={templateId}
        onLoaded={handleLoaded}
      />
    </Modal>
  );
}

export default ViewDevicesModal;
